module.exports = __webpack_public_path__ + "static/media/logo.54d910b4.png";